import { useCallback } from 'react';
import { posthogTrackEvent, QualityEvents } from '@/assets/posthog';

export const useQualityTracking = () => {
  const trackEvaluationStarted = useCallback((ticketId: string, evaluationType?: string) => {
    posthogTrackEvent({
      event: QualityEvents.EVALUATION_STARTED,
      properties: {
        ticketId,
        evaluationType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackEvaluationCompleted = useCallback((ticketId: string, score: number, evaluationTime: number) => {
    posthogTrackEvent({
      event: QualityEvents.EVALUATION_COMPLETED,
      properties: {
        ticketId,
        score,
        evaluationTime,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackScoreUpdated = useCallback((ticketId: string, oldScore: number, newScore: number) => {
    posthogTrackEvent({
      event: QualityEvents.SCORE_UPDATED,
      properties: {
        ticketId,
        oldScore,
        newScore,
        scoreDifference: newScore - oldScore,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackCommentAdded = useCallback((ticketId: string, commentType?: string) => {
    posthogTrackEvent({
      event: QualityEvents.COMMENT_ADDED,
      properties: {
        ticketId,
        commentType,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackTrackerViewed = useCallback((trackerId: string, trackerName?: string) => {
    posthogTrackEvent({
      event: QualityEvents.TRACKER_VIEWED,
      properties: {
        trackerId,
        trackerName,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackAuditPerformed = useCallback((auditType: string, ticketId?: string) => {
    posthogTrackEvent({
      event: QualityEvents.AUDIT_PERFORMED,
      properties: {
        auditType,
        ticketId,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  const trackValidationSet = useCallback((setId: string, action: string) => {
    posthogTrackEvent({
      event: QualityEvents.VALIDATION_SET_ACTION,
      properties: {
        setId,
        action,
        timestamp: new Date().toISOString(),
      },
    });
  }, []);

  return {
    trackEvaluationStarted,
    trackEvaluationCompleted,
    trackScoreUpdated,
    trackCommentAdded,
    trackTrackerViewed,
    trackAuditPerformed,
    trackValidationSet,
  };
};